<template>
    <div>
        <CCard>
            <CCardHeader class="grey-header d-flex">
                <div class="row flex-flow-column">
                    <CCol>
                        <strong>{{$t('classes.title')}}</strong>
                    </CCol>
                    <p class="desc">{{$t('classes.desc')}}</p>
                </div>
            </CCardHeader>


            <CCardBody>
                <div class="m-auto max-width-1000px">
                    <div class="multiselect-assignprice bs-input">
                        <cAirLine
                                v-model="airLine"
                                ctrlName="airline_name"
                                ctrlCode="airline_code"
                                :isShowCode="true"
                                :isMultiple="false"
                                :isSearchable="true"
                                :selValue="airLine"

                                @input="getClasses"
                        />
                    </div>
                    <!--                            <div class="card assign pricing-card sticky-title-bar">-->
                    <!--                                <div class="d-flex">-->
                    <!--                                    <label for="" class="title"> <strong>Select Airline</strong></label>-->
                    <!--                                    <div class="multiselect-assignprice inner-label-none">-->
                    <!--                                        <cAirLine-->
                    <!--                                                v-model="airLine"-->
                    <!--                                                ctrlName="airline_name"-->
                    <!--                                                ctrlCode="airline_code"-->
                    <!--                                                :isShowCode="true"-->
                    <!--                                                :isMultiple="false"-->
                    <!--                                                :isSearchable="true"-->
                    <!--                                                :selValue="airLine"-->

                    <!--                                                @input="getClasses"-->
                    <!--                                        />-->
                    <!--                                    </div>-->
                    <!--                                </div>-->
                    <!--                            </div>-->
                    <div v-if="classList" class="">
                        <div v-for="(clsList,index) of classList" :key="'cl'+index"
                             class="card assign pricing-card class">

                            <div class="card-head d-flex ai-center ">
                                <div class="align-left a-name">
                                    <h3 v-if="index=='myanmarClasses'">
                                        {{$t('classes.nationalClass')}}

                                    </h3>
                                    <h3 v-if="index=='foreignerClasses'">
                                        {{$t('classes.foreignClass')}}
                                    </h3>
                                      <h3 v-if="index=='classes'">
                                        {{$t('classes.nationalClass')}}
                                    </h3>
                                </div>
                                <!-- <div class="align-right d-flex"> -->
                                  <!-- <div v-if="index=='myanmarClasses'">
                                    <div v-if="isSaveMyanCls" class="d-flex">

                                      <button @click="addClass(classList,false)"
                                               class="btn btn-manage b-radius-3px hover-none btn-success btn-sm m-auto mr-10px"> -->

<!--                                          <img src="@imgPath/img/svg/icons/save.svg" width="28px" alt="">-->
                                          <!-- Save -->
<!--                                          {{$t('classes.save')}}-->
                                      <!-- </button>
                                    </div>
                                  </div> -->
                                    <!-- <div v-if="index=='foreignerClasses'">
                                        <div v-if="isSaveForeignCls" class="d-flex">
                                            <button @click="addClass(classList,false)"
                                                    class="btn btn-manage b-radius-3px hover-none btn-success btn-sm m-auto mr-10px"> -->

                                                <!--                                          <img src="@imgPath/img/svg/icons/save.svg" alt="" width="28px">-->
                                                <!-- {{$t('classes.save')}} -->
                                                <!--                                          Save-->
                                            <!-- </button>
                                        </div> -->
                                    <!-- </div> -->
                                  <div class="d-flex">
                                    <button
                                            @click="index=='myanmarClasses'?showAddClassModal(true):showAddClassModal(false)"

                                            class="btn ml-auto btn-lit-blue mob-w100 btn-success btn-sm m-auto" >
<!--                                        <img src="https://image.flaticon.com/icons/svg/1828/1828925.svg" alt="" width="20px">-->
                                        {{$t('classes.addClass')}}
<!--                                        Add-->
                                    </button>
                                  </div>

<!--                                    <button type="button" color="info"-->
<!--                                            class="btn btn-lit-blue mob-w100 btn-success btn-sm"></button>-->
                                </div>
                            <!-- </div> -->
                      <div>
                        <div v-if="index=='myanmarClasses'" class="classes-wrap" >
                          <draggable
                                  v-if="clsList.length>0"
                                  v-model="classList.myanmarClasses"
                          >

                            <transition-group>

                              <li
                                      class="list-group-item d-flex justify-content-between align-items-center"
                                      v-for="(classItem,index) in clsList"
                                      :key="'mc'+index"
                                      :class="{'list-group-item-dark': index%2==0}"
                              >

                              <span  class="text-ellipse">{{classItem}}</span>
                                <span>
<!--                          <CButton-->
                                                    <!--                                  @click="deleteClass(classItem)"-->
                                                    <!--                                  color="danger"-->
                                                    <!--                          >{{$t('classes.delete')}}</CButton>-->
                                    <div
                                  @click="showDeleteAlertModal(classItem,$t('classes.delCnfrmTxt',{clsItem: classItem}),true)"
                                  class="danger icon-btn mr-0"
                          >
                                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" class="c-icon c-icon-lg"  style="color: rgb(205, 6, 6);"><path d="M4.5 22.125c-0 0.003-0 0.006-0 0.008 0 0.613 0.494 1.11 1.105 1.116h12.79c0.612-0.006 1.105-0.504 1.105-1.117 0-0.003-0-0.006-0-0.009v0-15h-15zM6 8.625h12v13.125h-12z"></path><path d="M7.875 10.125h1.5v9.375h-1.5v-9.375z"></path><path d="M11.25 10.125h1.5v9.375h-1.5v-9.375z"></path><path d="M14.625 10.125h1.5v9.375h-1.5v-9.375z"></path><path d="M15.375 4.125v-2.25c0-0.631-0.445-1.125-1.013-1.125h-4.725c-0.568 0-1.013 0.494-1.013 1.125v2.25h-5.625v1.5h18v-1.5zM10.125 2.25h3.75v1.875h-3.75z"></path></svg>
<!--                                        <img src="https://image.flaticon.com/icons/svg/1345/1345823.svg" alt="" width="20px">-->
                                    </div>
                        </span>
                              </li>
                            </transition-group>
                          </draggable>
                        </div>
                        <div v-if="index=='foreignerClasses'" class="classes-wrap">
                          <draggable
                                  v-if="clsList.length>0"
                                  v-model="classList.foreignerClasses"
                          >
                            <transition-group>
                              <li
                                      class="list-group-item d-flex justify-content-between align-items-center"
                                      v-for="(classItem,index) in clsList"
                                      :key="'mc'+index"
                                      :class="{'list-group-item-dark': index%2==0}"
                              >
                               <span  class="text-ellipse">
                                    {{classItem}}
                               </span>
                                <span>
                                     <div @click="showClassesDeleteModal(classItem,$t('classes.delCnfrmTxt',{clsItem: classItem}))" class="danger icon-btn mr-0">
                                         <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" class="c-icon c-icon-lg"  style="color: rgb(205, 6, 6);"><path d="M4.5 22.125c-0 0.003-0 0.006-0 0.008 0 0.613 0.494 1.11 1.105 1.116h12.79c0.612-0.006 1.105-0.504 1.105-1.117 0-0.003-0-0.006-0-0.009v0-15h-15zM6 8.625h12v13.125h-12z"></path><path d="M7.875 10.125h1.5v9.375h-1.5v-9.375z"></path><path d="M11.25 10.125h1.5v9.375h-1.5v-9.375z"></path><path d="M14.625 10.125h1.5v9.375h-1.5v-9.375z"></path><path d="M15.375 4.125v-2.25c0-0.631-0.445-1.125-1.013-1.125h-4.725c-0.568 0-1.013 0.494-1.013 1.125v2.25h-5.625v1.5h18v-1.5zM10.125 2.25h3.75v1.875h-3.75z"></path></svg>
<!--                                         <img src="https://image.flaticon.com/icons/svg/1345/1345823.svg" alt="" width="20px">-->
                                     </div>
                                                    <!--                          <CButton-->
                                                    <!--                                  @click="deleteClass(classItem)"-->
                                                    <!--                                  color="danger"-->
                                                    <!--                          >{{$t('classes.delete')}}</CButton>-->
                        </span>
                              </li>
                            </transition-group>
                          </draggable>
                        </div>
 <div v-if="index=='classes'" class="classes-wrap">
                          <draggable
                                  v-if="clsList.length>0"
                                  v-model="classList.classes"
                          >
                            <transition-group>
                              <li
                                      class="list-group-item d-flex justify-content-between align-items-center"
                                      v-for="(classItem,index) in clsList"
                                      :key="'mc'+index"
                                      :class="{'list-group-item-dark': index%2==0}"
                              >
                              <span class="text-ellipse">
                                    {{classItem}}
                               </span>
                                <span>
                                     <div @click="showClassesDeleteModal(classItem,$t('classes.delCnfrmTxt',{clsItem: classItem}),false)" class="danger icon-btn mr-0">
                                         <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" class="c-icon c-icon-lg"  style="color: rgb(205, 6, 6);"><path d="M4.5 22.125c-0 0.003-0 0.006-0 0.008 0 0.613 0.494 1.11 1.105 1.116h12.79c0.612-0.006 1.105-0.504 1.105-1.117 0-0.003-0-0.006-0-0.009v0-15h-15zM6 8.625h12v13.125h-12z"></path><path d="M7.875 10.125h1.5v9.375h-1.5v-9.375z"></path><path d="M11.25 10.125h1.5v9.375h-1.5v-9.375z"></path><path d="M14.625 10.125h1.5v9.375h-1.5v-9.375z"></path><path d="M15.375 4.125v-2.25c0-0.631-0.445-1.125-1.013-1.125h-4.725c-0.568 0-1.013 0.494-1.013 1.125v2.25h-5.625v1.5h18v-1.5zM10.125 2.25h3.75v1.875h-3.75z"></path></svg>
<!--                                         <img src="https://image.flaticon.com/icons/svg/1345/1345823.svg" alt="" width="20px">-->
                                     </div>
                                                    <!--                          <CButton-->
                                                    <!--                                  @click="deleteClass(classItem)"-->
                                                    <!--                                  color="danger"-->
                                                    <!--                          >{{$t('classes.delete')}}</CButton>-->
                        </span>
                              </li>
                            </transition-group>
                          </draggable>
                        </div>
                            </div>
                        </div>
                    </div>
                </div>
                <!-- </div> -->
                <!--        <CRow>-->
                <!--          <CCol>-->
                <!--            <cAirLine-->
                <!--              v-model="airLine"-->
                <!--              ctrlName="airline_name"-->
                <!--              ctrlCode="airline_code"-->
                <!--              :isShowCode="true"-->
                <!--              :isMultiple="false"-->
                <!--              :isSearchable="true"-->
                <!--              :selValue="airLine"-->
                <!--              :label="'Select Airline'"-->
                <!--              @input="getClasses"-->
                <!--            />-->
                <!--          </CCol>-->
                <!--        </CRow>-->
            </CCardBody>
            <CCardFooter class="d-flex justify-content-end">
                <CRow>
                    <CCol>
                        <CButton
                                color="success"
                               @click="addClass(classList,false)"
                                class="action-c-btn pl-20px"

                        >
                            <img src="@imgPath/img/svg/icons/save.svg" height="16px" class="height-unset" />
                             {{$t('classes.save')}}
                        </CButton>

                        <!-- <CButton @click="onPermissionsFormSave(lsModulesPermissions)" color="success">
                                    {{$t('rolesPermissions.save')}}
                        </CButton>-->
                    </CCol>
                </CRow>
            </CCardFooter>
        </CCard>
        <!--        <div v-if="classList">-->
        <!--            <div v-for="(clsList,index) of classList" :key="'cl'+index">-->
        <!--                <CCard>-->
        <!--                    <CCardHeader>-->
        <!--                        <CRow>-->
        <!--                            <CCol v-if="index=='myanmarClasses'">-->
        <!--                                <strong>{{$t('classes.myanClass')}}</strong>-->
        <!--                            </CCol>-->
        <!--                            <CCol v-if="index=='foreignerClasses'">-->
        <!--                                <strong>{{$t('classes.foreignClass')}}</strong>-->
        <!--                            </CCol>-->
        <!--                        </CRow>-->
        <!--                    </CCardHeader>-->
        <!--                    <CCardBody>-->
        <!--                        <CRow>-->
        <!--                            <CCol>-->
        <!--                                <div v-if="index=='myanmarClasses'">-->
        <!--                                    <draggable-->
        <!--                                            v-if="clsList.length>0"-->
        <!--                                            v-model="classList.myanmarClasses"-->
        <!--                                            @change="isSaveMyanCls=true"-->
        <!--                                    >-->
        <!--                                        <transition-group>-->
        <!--                                            <li-->
        <!--                                                    class="list-group-item d-flex justify-content-between align-items-center"-->
        <!--                                                    v-for="(classItem,index) in clsList"-->
        <!--                                                    :key="'mc'+index"-->
        <!--                                                    :class="{'list-group-item-dark': index%2==0}"-->
        <!--                                            >-->
        <!--                                                {{classItem}}-->
        <!--                                                <span>-->
        <!--                          <CButton-->
        <!--                                  @click="deleteClass(classItem)"-->
        <!--                                  color="danger"-->
        <!--                          >{{$t('classes.delete')}}</CButton>-->
        <!--                        </span>-->
        <!--                                            </li>-->
        <!--                                        </transition-group>-->
        <!--                                    </draggable>-->
        <!--                                </div>-->
        <!--                                <div v-if="index=='foreignerClasses'">-->
        <!--                                    <draggable-->
        <!--                                            v-if="clsList.length>0"-->
        <!--                                            v-model="classList.foreignerClasses"-->
        <!--                                            @change="isSaveForeignCls=true"-->
        <!--                                    >-->
        <!--                                        <transition-group>-->
        <!--                                            <li-->
        <!--                                                    class="list-group-item d-flex justify-content-between align-items-center"-->
        <!--                                                    v-for="(classItem,index) in clsList"-->
        <!--                                                    :key="'mc'+index"-->
        <!--                                                    :class="{'list-group-item-dark': index%2==0}"-->
        <!--                                            >-->
        <!--                                                {{classItem}}-->
        <!--                                                <span>-->
        <!--                          <CButton-->
        <!--                                  @click="deleteClass(classItem)"-->
        <!--                                  color="danger"-->
        <!--                          >{{$t('classes.delete')}}</CButton>-->
        <!--                        </span>-->
        <!--                                            </li>-->
        <!--                                        </transition-group>-->
        <!--                                    </draggable>-->
        <!--                                </div>-->
        <!--                            </CCol>-->
        <!--                        </CRow>-->
        <!--                    </CCardBody>-->
        <!--                    <CCardFooter>-->
        <!--                        <CRow class="text-right ai-center">-->
        <!--                            <div v-if="index=='myanmarClasses'">-->
        <!--                                <CCol v-if="isSaveMyanCls">-->
        <!--                                    <CButton @click="addClass(classList,false)">{{$t('classes.save')}}</CButton>-->
        <!--                                </CCol>-->
        <!--                            </div>-->
        <!--                            <div v-if="index=='foreignerClasses'">-->
        <!--                                <CCol v-if="isSaveForeignCls">-->
        <!--                                    <CButton @click="addClass(classList,false)">{{$t('classes.save')}}</CButton>-->
        <!--                                </CCol>-->
        <!--                            </div>-->
        <!--                            <CCol>-->
        <!--                                <CButton-->
        <!--                                        @click="index=='myanmarClasses'?showAddClassModal(true):showAddClassModal(false)"-->
        <!--                                >{{$t('classes.addClass')}}-->
        <!--                                </CButton>-->
        <!--                            </CCol>-->
        <!--                        </CRow>-->
        <!--                    </CCardFooter>-->
        <!--                </CCard>-->
        <!--            </div>-->
        <!--        </div>-->
<CAlert v-if="alertValue" show color="danger">
                      <div  v-if="alertValue&&alertValue.hasOwnProperty('valueList')">
                <p  v-for="(value,index) in alertValue.valueList" :key="index">
                        {{value}}
                      </p>
                      </div>
                      <div v-if="alertValue&&alertValue.hasOwnProperty('codeList')">
                      <span>{{$t("cAlert.errorCode")+' : '}}</span><span  v-for="(code,index) in alertValue.codeList" :key="index">
                        {{code +' '}}
                      </span>
                      </div>
                            <div  v-if="alertValue&&alertValue.constructor==String">
                <p  >
                        {{alertValue}}
                      </p>
                      </div>
                      </CAlert>        <ValidationObserver v-slot="{ handleSubmit }">
            <form @submit.prevent="handleSubmit(addNewClass)">
                <CModal
                        v-if="showModal"
                        :show.sync="showModal"
                        :backdrop="true"
                        :closeOnBackdrop="false"
                        :centered="true"
                        class="bclear-popup"
                >

                    <template #header-wrapper>

                            <header class="card-header position-relative">
                                <div class="d-flex ai-center">
                                    <img src="@imgPath/img/svg/icons/blue-icons/flight-class.svg" width="33px" alt="">
                                    <div style="padding-left: 15px;"> {{$t('classes.addNew')}}</div>
                                </div>
                                <div class="close" @click="showModal=false"><img src="@imgPath/img/svg/icons/cross-radius.svg" alt=""></div>
                            </header>


                    </template>
                    <template #body-wrapper>
                        <CCardBody >
                            <div class="wrap">
                                <div>
<!--                                    <label>{{$t('classes.clsName')}}</label>-->

                                    <cTextInputComponent
                                            type="text"
                                            v-model="newClass"
                                            placeholder="Enter class name"
                                            rules="required|max:15"
                                            label="Class Name"
                                            @input="onEdit"
                                    />
                                </div>
                            </div>
                        </CCardBody>
                    </template>
                    <template #footer-wrapper>
                        <footer class="card-footer mt-12px">
                        <CCardBody class="d-flex justify-content-end pt-0px mob-pl-pr-none pb-8px pr-0px">
                            <div class="w-100">
                            <div class="cta-button-wrapper">

                                    <CButton @click="showModal=false"  class="btn primary-btn danger">{{$t('classes.cancel')}}</CButton>


                                    <CButton type="submit" class="btn primary-btn">{{$t('classes.add')}}</CButton>

                            </div>
                            </div>
                        </CCardBody>
                         <CAlert v-if="classAlert" show color="danger">{{ classAlert }}</CAlert>
                        </footer>
                    </template>
                   
                </CModal>
            </form>
        </ValidationObserver>
        <cAlertModal v-if="isShowAlertModal"
                :buttonList="modalButton"
                :status="modalStatus"
                :show="isShowAlertModal"
                :desc="confirmText"
        ></cAlertModal>
    </div>
</template>

<script>
    import router, {navigate, goBack,updateDataEdited} from "../../router/index";
    import {ValidationObserver, localize} from "vee-validate";
    import {
        PATHNAME,
        COMPONENT_NAME,
        ALERT_MODAL_STATUS
    } from "../../../src/util/constants";
    import cAirLine from "../../components/pricing/cAirLine";
    import {
        LOG_TYPE,
        FILE_NAME,
        HTTP_CODES,
        API_VALUES
    } from "../../config/API_DATA";
    import BaseConfiguration from "../../config/base";
    import Logger from "../../services/logger";
    import {VALIDATE_SUCCESS_RES, getErrorMessage} from "../../util/apiValidate";
    import {handleJWT, getErrorAlertValue, addClassToBody, removeClassBody} from "../../util/util";
    import apiToolsClasses from "../../services/apiToolsClasses";
    import draggable from "vuedraggable";
    import cTextInputComponent from "../../components/form/cTextInputComponent";
    import apiAddAirlineClass from "../../services/apiAddAirlineClass";
    import cAlertModal from "../../components/form/cAlertModal";
    // import nb from "../../translations/validation/nb.json";
    // import en from "../../translations/validation/en.json";

    // localize({
    //     en: {
    //         messages: en.messages
    //     },
    //     nb: {
    //         messages: nb.messages
    //     }
    // });

    export default {
        name: COMPONENT_NAME.TOOLS,

        components: {
            cAirLine,
            draggable,
            ValidationObserver,
            cTextInputComponent,
            cAlertModal
        },

        data() {
            return {
                airLine: {
                    airline_code: null,
                    airline_name: null,
                    logourl: null
                },
                newClass: null,
                isMyanmarClass: false,
                alertValue: null,
                showModal: false,
                modalButton: [],
                isShowAlertModal: false,
                modalStatus: ALERT_MODAL_STATUS.INFO,
                confirmText: null,
                classList: [],
                SelClass: null,
                classAlert: null,
               // isSaveMyanCls: false,
               // isSaveForeignCls: false
                // isSaveClass: false
            };
        },
  
        methods: {
            onEdit() {
        try {
          if(BaseConfiguration.isDebug) console.log("onEdit");
        this.classAlert=null;
    // updateDataEdited(true);
        } catch (err) {
                let body = Logger.buildRequest(
                  FILE_NAME.CLASSES,
                  "error in onEdit",
                  err.toString(),
                  "onEdit",
                  LOG_TYPE.ERROR
                );
                Logger.getResponse(body);
              }
         
        }, 

            showAlert(val) {
                 this.alertValue = val;
            },
            showClassesDeleteModal(classItem, deleteText){
                if(classItem && deleteText){
                this.SelClass = classItem;
                this.showAlertModal(ALERT_MODAL_STATUS.INFO,deleteText,true)
                }
                else
                this.SelClass = null;
            },

            showDeleteAlertModal(classItem, deleteText, pIsMyanmarClass){
                if(classItem && deleteText){
                this.SelClass = classItem;
                this.isMyanmarClass = pIsMyanmarClass;
                this.showAlertModal(ALERT_MODAL_STATUS.INFO,deleteText,true)
                }
                else
                this.SelClass = null;
            },

            showAlertModal(status, val, isDeleteAlert) {
                if (status && val) {
                    this.isShowAlertModal = true;
                    this.modalStatus = status;
                    if(isDeleteAlert){
                       this.modalButton = [
                        {
                            name: this.$t('classes.no'),
                            func: this.navigateToClasses,
                            color: "danger"
                        },
                        {
                            name: this.$t('classes.yes'),
                            func: this.deleteClass,
                            color: "success"
                        }
                    ]; 
                    }else{
                    this.modalButton = [
                        {
                            name: this.$t('classes.ok'),
                            func: this.navigateToClasses,
                            color: "success"
                        }
                    ];
                    }
                    this.confirmText = val;
                }
            },

           async navigateToClasses() {
                this.isShowAlertModal = false;
                let airlineObj = this.airLine;
                await this.getClasses(airlineObj);
            },

            showAddClassModal(pIsMyanmarClass) {
                this.newClass = null;
                this.showModal = true;
                this.classAlert = null
                this.isMyanmarClass = pIsMyanmarClass;
            },

           async addNewClass() {
                try {
                    if (BaseConfiguration.isDebug) console.log("addNewClass");
                    //let retValue;
                    let newClass = this.newClass.replace(/ /g,'').toUpperCase();
                    
                    if (this.classList) {
                         if(this.classList.classes){
                             if (this.classList.classes&&this.classList.classes.includes(newClass)) {
                               this.classAlert= this.$t("classes.existAlert");
                            } else {
                                this.classAlert = null;
                                this.classList.classes.push(newClass);
                                await this.addClass(this.classList, true);
                            }

                         }else{
                          if (this.isMyanmarClass) {
                            if (this.classList.myanmarClasses&&this.classList.myanmarClasses.includes(newClass)||this.classList.foreignerClasses.includes(newClass)) {
                                this.classAlert = this.$t("classes.existAlert")
                            } else {
                                this.classAlert = null;
                                this.classList.myanmarClasses.push(newClass);
                                await this.addClass(this.classList, true);
                            }
                        } else {
                            if (this.classList.foreignerClasses&&this.classList.foreignerClasses.includes(newClass)||this.classList.myanmarClasses.includes(newClass)) {
                               this.classAlert= this.$t("classes.existAlert");
                            } else {
                                this.classAlert = null;
                                this.classList.foreignerClasses.push(newClass);
                                await this.addClass(this.classList, true);
                            }
                        }
                        
                         }
                        
                    }
                    updateDataEdited(true);
                //    await this.addClass(this.classList, true);
                } catch (err) {
                    let body = Logger.buildRequest(
                        FILE_NAME.CLASSES,
                        "error in addNewClass",
                        err.toString(),
                        "addNewClass",
                        LOG_TYPE.ERROR
                    );
                    Logger.getResponse(body);
                }
                // return retValue;
            },

           async deleteClass() {
                try {
                    if (BaseConfiguration.isDebug) console.log("deleteClass");
                  
                    let classToDelete = null
                   if(this.SelClass){
                       classToDelete = this.SelClass
                       if(this.classList){
                           
                           if(this.isMyanmarClass &&this.classList.myanmarClasses&& this.classList.myanmarClasses.length>0){
                               for (let index = 0; index < this.classList.myanmarClasses.length; index++) {
                                   const myanClass = this.classList.myanmarClasses[index];
                                   if(myanClass == classToDelete){
                                       this.classList.myanmarClasses.splice(index,1);
                                       break;
                                   }
                               }
                           }else if(this.classList.foreignerClasses&&this.classList.foreignerClasses.length>0){
                               for (let index = 0; index < this.classList.foreignerClasses.length; index++) {
                                   const foreignClass = this.classList.foreignerClasses[index];
                                   if(foreignClass == classToDelete){
                                       this.classList.foreignerClasses.splice(index,1);
                                       break;
                                   }
                               }
                           }else  if(this.classList.classes&&this.classList.classes.length>0){
                               for (let index = 0; index < this.classList.classes.length; index++) {
                                   const classes = this.classList.classes[index];
                                   if(classes == classToDelete){
                                       this.classList.classes.splice(index,1);
                                       break;
                                   }
                               }
                           }
                       }
                    await this.addClass(this.classList,true,classToDelete);
                   
                    }
                } catch (err) {
                    let body = Logger.buildRequest(
                        FILE_NAME.CLASSES,
                        "error in deleteClass",
                        err.toString(),
                        "deleteClass",
                        LOG_TYPE.ERROR
                    );
                    Logger.getResponse(body);
                }
                //return retValue;
            },

            async addClass(pClassList, isAddClass, deletedClass) {
                try {
                    if (BaseConfiguration.isDebug) console.log("addClass");
                    // let retValue;

                    let airlineCode = this.airLine.airline_code;
                    // let newClass = this.newClass;
                    let classObj;
                    if (pClassList) classObj = JSON.parse(JSON.stringify(pClassList));
                   
                    let addClassRequest = apiAddAirlineClass.buildRequest(
                        airlineCode,
                        classObj
                    );

                    if (addClassRequest) {
                        let addClassResponse = await apiAddAirlineClass.getResponse(
                            addClassRequest
                        );
                        if (VALIDATE_SUCCESS_RES(addClassResponse)) {
                            this.showModal = false;
                            this.showAlert(null);
                            if (isAddClass == true){
                                if(deletedClass){
                                    this.showAlertModal(
                                    ALERT_MODAL_STATUS.SUCCESS,
                                    this.$t("classes.deleteSuccess",{clsItem:deletedClass})
                                );
                                 this.SelClass = null;
                                }else
                                this.showAlertModal(
                                    ALERT_MODAL_STATUS.SUCCESS,
                                    this.$t("classes.addSuccess")
                                );
                            }
                            else if (isAddClass == false)
                                this.showAlertModal(
                                    ALERT_MODAL_STATUS.SUCCESS,
                                    this.$t("classes.saveSuccess")
                                );                                    
                        } else {
                            this.isShowAlertModal = false;
                            let error = getErrorMessage(addClassResponse);
                            let isJwt = handleJWT(error);
                            if (!isJwt) {
                                this.showAlert(getErrorAlertValue(error));
                            }
                        }
                    } else {
                        throw "invalid request";
                    }
                    updateDataEdited(false)
                } catch (err) {
                    let body = Logger.buildRequest(
                        FILE_NAME.CLASSES,
                        "error in addClass",
                        err.toString(),
                        "addClass",
                        LOG_TYPE.ERROR
                    );
                    Logger.getResponse(body);
                }
                // return retValue;
            },

            async getClasses(airLineObj) {
                try {
                    if (BaseConfiguration.isDebug) console.log("getClasses");
                    // let retValue;
                    let req = JSON.parse(JSON.stringify(airLineObj));

                    let classRequest = apiToolsClasses.buildRequest(req);

                    if (classRequest) {
                        let classResponse = await apiToolsClasses.getResponse(classRequest);
                        if (VALIDATE_SUCCESS_RES(classResponse)) {
                            // this.showAcknowledgeAlert();
                            this.showAlert(null);
                            this.classList = classResponse.data.data;
                        } else {
                            let error = getErrorMessage(classResponse);
                            let isJwt = handleJWT(error);
                            if (!isJwt) {
                                this.showAlert(getErrorAlertValue(error));
                            }
                        }
                    } else {
                        throw "invalid request";
                    }
                } catch (err) {
                    let body = Logger.buildRequest(
                        FILE_NAME.CLASSES,
                        "error in getClasses",
                        err.toString(),
                        "getClasses",
                        LOG_TYPE.ERROR
                    );
                    Logger.getResponse(body);
                }
                //return retValue;
            }
        },
        beforeCreate() {
            addClassToBody(COMPONENT_NAME.CLASSES);
        },

        beforeDestroy() {
            removeClassBody();
        },
    };
</script>
